import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
	selector: 'app-course-learning-home-note',
	templateUrl: './course-learning-home-note.component.html',
	styleUrls: ['./course-learning-home.component.css', '../../assets/css/font-size.css']
})

export class CourseLearningHomeNoteComponent implements OnInit, AfterViewInit {
	course: any;
	showCourse:boolean = false;
	learningPathId: number = 0;
	courseId: number = 0;
	firstEnter:number = 0;
  assetsRoute: string = "../../assets";
	constructor(private apiService: ApiService,
		private commonService: CommonService,
		private route: ActivatedRoute,
		private router: Router) {}

	ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
		this.route.params.subscribe(params => {
			this.learningPathId = params['learningPathId'];
			this.courseId = params['courseId'];
			this.firstEnter = params['firstEnter'];
			this.getCourse();
		});

	}

	getCourse() {
		this.apiService.getCourse("" + this.courseId + "").subscribe(course => {
			this.course = course;
			this.showCourse = true;
		});
	}

	ngAfterViewInit() {
		this.commonService.initPage();
		$('body').css("height", "auto");
	}

	// 关闭精华笔记
	closeNote() {
		let link = ["course", this.learningPathId, this.courseId,this.firstEnter];
		this.router.navigate(link);
	}

  openPDF(number){
    window.open("../../assets/pdf/jinghua11-"+number+".pdf","_blank");
  }


}



// WEBPACK FOOTER //
// ./src/app/course-learning-home/course-learning-home-note.component.ts